import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
  Box,
} from '@mui/material';
import {
  Casino,
  Close,
} from '@mui/icons-material';
import PlanningPokerRoom from './PlanningPokerRoom';

interface PlanningPokerButtonProps {
  issueId: string;
  issueTitle: string;
  issueDescription?: string;
  onEstimationComplete?: (estimate: number) => void;
  variant?: 'button' | 'icon';
  size?: 'small' | 'medium' | 'large';
}

const PlanningPokerButton: React.FC<PlanningPokerButtonProps> = ({
  issueId,
  issueTitle,
  issueDescription,
  onEstimationComplete,
  variant = 'icon',
  size = 'small',
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEstimationComplete = (estimate: number) => {
    onEstimationComplete?.(estimate);
    setOpen(false);
  };

  if (variant === 'button') {
    return (
      <>
        <Button
          variant="outlined"
          startIcon={<Casino />}
          onClick={handleOpen}
          size={size}
          sx={{
            borderColor: 'primary.main',
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.main',
              color: 'white',
            },
          }}
        >
          Planning Poker
        </Button>

        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              minHeight: '80vh',
              maxHeight: '90vh',
            },
          }}
        >
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <span>Planning Poker - {issueTitle}</span>
              <IconButton onClick={handleClose} size="small">
                <Close />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <PlanningPokerRoom
              issueId={issueId}
              issueTitle={issueTitle}
              issueDescription={issueDescription}
              onClose={handleClose}
              onEstimationComplete={handleEstimationComplete}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <>
      <Tooltip title="Start Planning Poker">
        <IconButton
          onClick={handleOpen}
          size={size}
          sx={{
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.main',
              color: 'white',
            },
          }}
        >
          <Casino />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: '80vh',
            maxHeight: '90vh',
          },
        }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>Planning Poker - {issueTitle}</span>
            <IconButton onClick={handleClose} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <PlanningPokerRoom
            issueId={issueId}
            issueTitle={issueTitle}
            issueDescription={issueDescription}
            onClose={handleClose}
            onEstimationComplete={handleEstimationComplete}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PlanningPokerButton;
